import { isAxiosError } from 'axios';
import type { ValidationGate } from '@/types/auth.types';
import {
  CROSS_VALIDATION_ERROR_CODE,
  FALLBACK_BLOCK_THRESHOLD,
  FALLBACK_VALIDATIONS_REQUIRED,
  FALLBACK_WARNING_THRESHOLD,
} from './constants';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const SYNTHETIC_BLOCKED_GATE: ValidationGate = {
  isBlocked: true,
  contributionsSinceLastValidation: FALLBACK_BLOCK_THRESHOLD,
  blockThreshold: FALLBACK_BLOCK_THRESHOLD,
  warningThreshold: FALLBACK_WARNING_THRESHOLD,
  validationsSinceBlock: 0,
  validationsRequired: FALLBACK_VALIDATIONS_REQUIRED,
  blockedAt: null,
};

/**
 * Detecte une reponse 403 CROSS_VALIDATION_REQUIRED et retourne le gate a jour.
 * Si le corps ne contient pas de gate exploitable, retourne un gate "bloque" synthetique
 * plutot que de laisser passer la soumission silencieusement.
 */
export function isCrossValidationBlockedError(error: unknown): ValidationGate | null {
  if (!isAxiosError(error)) return null;
  if (error.response?.status !== 403) return null;

  const data = error.response?.data;
  if (!isRecord(data) || data.code !== CROSS_VALIDATION_ERROR_CODE) return null;

  const gate = data.validationGate;
  if (
    isRecord(gate) &&
    typeof gate.isBlocked === 'boolean' &&
    typeof gate.contributionsSinceLastValidation === 'number'
  ) {
    return {
      isBlocked: gate.isBlocked,
      contributionsSinceLastValidation: gate.contributionsSinceLastValidation,
      blockThreshold: typeof gate.blockThreshold === 'number' ? gate.blockThreshold : FALLBACK_BLOCK_THRESHOLD,
      warningThreshold: typeof gate.warningThreshold === 'number' ? gate.warningThreshold : FALLBACK_WARNING_THRESHOLD,
      validationsSinceBlock: typeof gate.validationsSinceBlock === 'number' ? gate.validationsSinceBlock : 0,
      validationsRequired: typeof gate.validationsRequired === 'number' ? gate.validationsRequired : FALLBACK_VALIDATIONS_REQUIRED,
      blockedAt: typeof gate.blockedAt === 'string' ? gate.blockedAt : null,
    };
  }

  return SYNTHETIC_BLOCKED_GATE;
}
